import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Button, DialogActions, Grid, MenuItem, Typography} from "@mui/material";
import SimpleDialog from "../../../../widgets/dialogs/SimpleDialog";
import {
	cognomeRegisterNone,
	emailRegisterNone,
	nomeRegisterNone,
	phoneRegisterPrivate
} from "../../../../../utils/RegisterUtils";
import CustomText from "../../../../widgets/inputs/CustomText";
import {useFormContext} from "react-hook-form";
import {relations} from "../../../../../utils/dictionaries/Generics";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {IntervistaContext, QuarantenaContext} from "../IntervistaOld";
import {generateIntervistaIncompleta} from "../../../../../services/IntervistaServices";
import {useParams} from "react-router-dom";
import CustomSelect from "../../../../widgets/inputs/CustomSelect";
import moment from "moment";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {AppContext} from "../../../../../App";

export const AddContattoDialog = ({open, handleClose, contatti, setContatti}) => {
	const {errors, register, control, getValues, setValue} = useFormContext();
	const quarantenaContext = useContext(QuarantenaContext);
	const intervistaContext = useContext(IntervistaContext);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);
	const [index, setIndex] = useState("");
	let {idSoggetto, idFocolaio} = useParams();
	
	const addContatti = () => {
		let data = getValues();
		if (data.sendMail === "true" && (data.incompletaEmail === "" || data.incompletaEmail === null)) {
			setOpenSnackbar("warning", "Inserisci una email valida per inviare l'intervista al paziente!", appContext.dispatch)
		} else {
			let incompleta = {
				index: contatti.length,
				nome: data.incompletaNome,
				cognome: data.incompletaCognome,
				email: data.incompletaEmail,
				cellulare: data.incompletaCell,
				note: data.incompletaNote,
				tipoRelazione: data.incompletaRel,
				type: data.incompletatipoSoggetto,
				data: data.incompletaData,
				sendMail: data.sendMail,
				idAnagraficaPazienteZero: idSoggetto
			}
			setContatti(prevState => [...prevState, incompleta]);
			setValue("incompletaCognome", "");
			setValue("incompletaNome", "");
			setValue("incompletaCell", "");
			setValue("incompletaData", null);
			setValue("incompletaEmail", "");
			setValue("incompletaNote", "");
			setValue("incompletaRel", "");
		}
	}
	
	const generateAndGoToIncompleta = useCallback((contatto, index) => {
		if (quarantenaContext.state.idFocolaio === "") {
			alert("Ops, non hai ancora creato l'intervista del caso indice o qualcosa è andato storto")
		} else {
			setSubmit(true)
			setIndex(index)
			generateIntervistaIncompleta({
				...contatto,
				note: "#" + contatto.tipoSoggetto + "\n tipo relazione:" + contatto.tipoRelazione + "\n Ultimo contatto: " + (contatto.data ? moment(contatto.data).format("DD/MM/YYYY") : " ND") + "\n " + contatto.note,
				idFocolaio: idFocolaio ? idFocolaio : quarantenaContext.state.idFocolaio,
				idAnagraficaPazienteZero: idSoggetto,
				type: contatto.tipoSoggetto,
				sendMail: contatto.sendMail,
				sendSMS: false,
			}, intervistaContext.dispatch, contatto.sendMail !== "true")
		}
	}, [intervistaContext.dispatch, quarantenaContext.state.idFocolaio, idSoggetto, idFocolaio])
	
	useEffect(() => {
		if (submit && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta === "") {
			setSubmit(false);
			if (contatti[index].sendMail === "true") {
				setOpenSnackbar("success", "La mail è stata inviata al cittadino, puoi continuare ad aggiungere contatti o concludere l'intervista", appContext.dispatch)
				setContatti(prev => prev.filter(c => c.index !== index))
			} else {
				setOpenSnackbar("success", "Verrà aperta in una nuova pagina l'intervista, dovrai completarla!", appContext.dispatch)
				setContatti(prev => prev.filter(c => c.index !== index))
			}
		} else if (submit && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaContext.state.errorAddIntervistaIncompleta, appContext.dispatch)
		}
	}, [submit, intervistaContext.state.loadingAddIntervistaIncompleta, intervistaContext.state.errorAddIntervistaIncompleta, appContext.dispatch, contatti, index, setContatti])
	
	return (
		<React.Fragment>
			<SimpleDialog
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"lg"}
				title={"Aggiungi contatti in modo rapido"}
				content={
					<React.Fragment>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Typography color={"textSecondary"} style={{padding: 10}}>
									Clicca sui bottoni per compilare le interviste dei pazienti
								</Typography>
							</Grid>
							<Grid item xs={12} style={{display: "flex", flexWrap: "nowrap"}}>
								{
									contatti.length === 0 ? "Non ci sono contatti al momento... aggiungili da qui o dallo step finale dell'intervista." :
										contatti.map((contatto, index) => {
											return <Button variant={"contained"} disableElevation color={"secondary"} key={index}
											               onClick={() => generateAndGoToIncompleta(contatto, index)}
											               style={{textAlign: "left", borderRadius: 24, display: "block", margin: 5}}>
												Nome: <b>{(contatto.nome ? contatto.nome : "--")}</b><br/>
												Cognome: <b>{(contatto.cognome ? contatto.cognome : "--")}</b><br/>
												Cell: <b>{(contatto.cellulare ? contatto.cellulare : "--")}</b><br/>
												Mail: <b>{(contatto.sendMail === "true" ? "Sì" : "No")}</b><br/>
											</Button>
										})
								}
							</Grid>
							<Grid item xs={12}>
								<Typography color={"textSecondary"} style={{padding: 10}}>
									Indica dei dati per poter poi compilare l'intervista incompleta
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<CustomText
									control={control}
									rules={cognomeRegisterNone}
									name={"incompletaCognome"}
									label={"Cognome"}
									autoFocus={false}
									error={errors["incompletaCognome"]}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<CustomText
									control={control}
									rules={nomeRegisterNone}
									name={"incompletaNome"}
									label={"Nome"}
									autoFocus={false}
									error={errors["incompletaNome"]}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<CustomText
									control={control}
									rules={phoneRegisterPrivate}
									name={"incompletaCell"}
									placeholder={"3333333333"}
									label={"Cellulare"}
									autoFocus={false}
									error={errors["incompletaCell"]}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<CustomDateInput
									label={"Ultimo contatto"}
									control={control}
									defaultValue={null}
									maxDate={new Date()}
									rules={{required: false}}
									name={"incompletaData"}
									error={errors["incompletaData"]}
								/>
							</Grid>
							<Grid item xs={12}>
								<CustomText
									control={control}
									rules={emailRegisterNone}
									name={"incompletaEmail"}
									label={"Email"}
									autoFocus={false}
									error={errors["incompletaEmail"]}
								/>
							</Grid>
							<Grid item xs={12}>
								<CustomMultiText
									inputRef={register({required: false})}
									label={"Note"}
									autoFocus={false}
									name={"incompletaNote"}
									error={errors["incompletaNote"]}
									rows={2}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomAutoComplete
									name={"incompletaRel"}
									label={"Tipo di relazione"}
									control={control}
									options={[...Object.keys(relations).sort(), ""]}
									multiple={false}
									rules={{required: false}}
									error={errors["incompletaRel"]}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomSelect
									name={"incompletatipoSoggetto"}
									label={"Tipo contatto"}
									control={control}
									defaultValue={"contatticonviventi."}
									autoFocus={false}
									none={true}
									noneValue={""}
									rules={{required: true}}
									error={errors["incompletatipoSoggetto"]}
								>
									<MenuItem value={"contatticonviventi."}>
										Covivente
									</MenuItem>
									<MenuItem value={"contattistretti."}>
										Stretto
									</MenuItem>
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomSelect
									name={"sendMail"}
									label={"Invia mail"}
									control={control}
									defaultValue={"false"}
									autoFocus={false}
									none={true}
									noneValue={""}
									rules={{required: true}}
									error={errors["sendMail"]}
								>
									<MenuItem value={"true"}>
										Invia
									</MenuItem>
									<MenuItem value={"false"}>
										No
									</MenuItem>
								</CustomSelect>
							</Grid>
						</Grid>
					</React.Fragment>
				}
				actions={
					<DialogActions>
						<Button variant={"text"} size={"small"} style={{borderRadius: 24}} disableElevation
						        onClick={() => handleClose(false)}>
							<b>Chiudi</b>
						</Button>
						<Button variant={"contained"} color={"primary"} size={"small"} style={{borderRadius: 24}} disableElevation
						        onClick={addContatti}>
							<b>Salva e aggiungi</b>
						</Button>
					</DialogActions>
				}
			/>
		</React.Fragment>
	);
}
